import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { SearchService } from '../search.service';
import { AppService } from 'app/app.service';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-search-result-dialog',
    imports: [
        CommonModule
    ],
    templateUrl: './search-result-dialog.component.html',
    styleUrl: './search-result-dialog.component.scss'
})
export class SearchResultDialogComponent {

  constructor(
    private router: Router,
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private searchService: SearchService,
    public appService: AppService 
  ) { }


  onClose(): void {
    this.searchService.closeDialog();
    localStorage.removeItem('searchResponse');
    this.router.navigate(['search'], { queryParams: { form: this.config.data.form } });
  }

}
